import { Empty, Pagination, Spin } from "antd";
import { AlertCircle } from "lucide-react";
import { FC } from "react";
import { BookingItem } from "./booking-item";

interface BookingListProps {
  isLoading: boolean;
  bookings: any[];
  filters: any;
  setFilters: (filters: any) => void;
  totalItems: number;
}

export const BookingList: FC<BookingListProps> = ({
  isLoading,
  bookings,
  filters,
  setFilters,
  totalItems,
}) => {
  return (
    <div className="bg-white rounded-lg border shadow-sm overflow-hidden">
      {/* Table Header */}
      <div className="bg-gray-50 p-4 border-b">
        <div className="grid grid-cols-12 gap-4 font-medium text-gray-500 text-sm">
          <div className="col-span-2">ID</div>
          <div className="col-span-3">Client</div>
          <div className="col-span-2">Project</div>
          <div className="col-span-1">Date</div>
          <div className="col-span-1">Status</div>
          <div className="col-span-1">Amount</div>
          <div className="col-span-2">Actions</div>
        </div>
      </div>

      {/* Table Body */}
      {isLoading ? (<Spin size="large" className="p-8 flex justify-center items-center h-[55vh] w-full" />) : bookings.length > 0 ? (
        <div className="divide-y">
          {bookings.map((booking) => (
            <BookingItem key={booking.id} booking={booking} />
          ))}
        </div>
      ) : (
        <div className="p-8 text-center">
          <Empty
            image={
              <AlertCircle size={40} className="mx-auto text-gray-300" />
            }
            description={
              <div>
                <h3 className="text-lg font-medium text-gray-700">
                  No bookings found
                </h3>
                <p className="text-gray-500 mt-1">
                  Try adjusting your search or filter criteria
                </p>
              </div>
            }
          />
        </div>
      )}

      {/* Pagination */}
      {totalItems > 0 && (
        <div className="p-4 border-t bg-gray-50 flex justify-between items-center">
          <div className="text-sm text-gray-500">
            Showing {bookings.length} of {totalItems} bookings
          </div>
          <Pagination
            total={totalItems}
            current={filters?.page}
            onChange={(page) => setFilters({ ...filters, page })}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
};
